import mitt, { type Emitter } from 'mitt';
import { GitCodeLayoutEmitter } from 'vue-layout-gitcode';

export type EventBus = {
  logout?: boolean;
  login?: any;
  tocChange?: any;
  updateNaviBar: void;
  responseError: string;
  updateMrAction: string;
  updateLockStatusAndList: string;
  updateIssueAction: string;
  notice: void;
  forbiddenRefresh: void;
  microRouterChange: void;
  openModal: void;
  updateNotice: number;
  updateUserInfo: Record<string, any>;
  reportView: void; // 子应用中的路由主动上报
  handleAsideVisible: string;
  updateHeader: void; //  banner通知
  globalTaskReport: void; // 全局任务上报
  crossFileClick: void; // readme跨文件跳转
  updateNoticeCount: string; // 更新消息计数
  repoTreeLoading: boolean; // 在 repoDir | repoDashboardBranch 场景，启用全局loading遮盖
  closeChatSlider: void; // 关闭侧边栏
  openFullScreen: void; // 打开全屏
  openFilePath: void; // 打开文件地址
  needLogin: void; // 需要登录
  taskNoticeConfirm: void; // 任务通知确认
  resetPwdFromChange: void; // 从修改密码-触发重置密码弹窗，重置成功
  userSettingResetPwdSuccess: void; // 从修改密码-触发重置密码弹窗，重置成功，传递给 micro-user-center
  signIn: void; // 签到
  fileDiffCommentJump: void; // 触发检视意见跳转
  metadataUpdate: string; // ai仓元数据更新
  toolsFloatExpand: void; // 手动展开浮动工具栏
  refreshRepoRouterView: void; // 刷新 RepoLayout 中的 RouterView
};

const emitter = mitt<EventBus>();

// 转发 - 由 GitCode layout 组件库处理的事件
const GitCodeLayoutProxyEvents = ['login', 'logout', 'updateNotice', 'updateNoticeCount'];

const getEmitter = (evtName: keyof EventBus): Emitter<EventBus> =>
  GitCodeLayoutProxyEvents.includes(evtName) ? (GitCodeLayoutEmitter as unknown as Emitter<EventBus>) : emitter;

export const addEventListener = (evtName: keyof EventBus, callback: (payload: any) => void) => emitter.on(evtName, callback);

export const emitEvent = (evtName: keyof EventBus, payload?: any) => getEmitter(evtName).emit(evtName, payload);

export const offEvent = (evtName: keyof EventBus, handler?: any) => getEmitter(evtName).off(evtName, handler || undefined);

export const offEvents = (list: Array<keyof EventBus>) => {
  list.forEach(offEvent);
};

export const getEvents = () => emitter.all;

export const clearEvent = () => emitter.all.clear();

export default emitter;
